import './aws-config';
import { register as registSwiperErelements } from 'swiper/element/bundle';

import { bootstrapApplication } from '@angular/platform-browser';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

registSwiperErelements();

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
